/**
 * Telegram deep link integration API service.
 */
import apiClient from './client';

export interface TelegramStatus {
  linked: boolean;
  telegram_id?: number;
  telegram_username?: string;
  first_name?: string;
}

export interface InitiateLinkResponse {
  deep_link: string;
  token: string;
}

export const telegramApi = {
  getStatus: async (): Promise<TelegramStatus> => {
    const response = await apiClient.get<TelegramStatus>('/api/v1/telegram/status/');
    return response.data;
  },

  initiateLink: async (): Promise<InitiateLinkResponse> => {
    const response = await apiClient.post<InitiateLinkResponse>('/api/v1/telegram/initiate-link/');
    return response.data;
  },

  unlink: async (): Promise<{ success: boolean }> => {
    const response = await apiClient.post<{ success: boolean }>('/api/v1/telegram/unlink/');
    return response.data;
  },
};
